import React, { useState, useEffect } from 'react';
import axios from "axios";
import Sidebar from '../SideBar/Sidebar';
import Title from '../Containers/Title';
import db from '../../Db/db';



function Affect({ url }) {
    const json = localStorage.getItem("token")
    const userInfo = JSON.parse(json);
    const [affect, setAffect] = useState([])
    
    const [showSelect, setShowSelect] = useState(false);
    const [addComm, setAddComm] = useState(false);
    const [commerciaux, setCommerciaux] = useState([]);
    const [agence, setAgence] = useState([]);
    const [selectedAgence, setSelectedAgence] = useState("aucun");
    const [associerDissocier, setAssocierDissocier] = useState("aucun");
    const [currentSearch, setCurrentSearch] = useState("");
    const [submitData, setSubmitData] = useState({});
    const [allClients, setAllClients] = useState([]);
    const [selectedClients, setSelectedClients] = useState([]);
    const [allChecked, setAllChecked] = useState(false);




    useEffect(() => {
        async function fetchData() {
            const data1 = await db.clients.toArray();
            setAllClients(data1/*.filter(d => d.typeClient === 'client-effectif' || d.typeClient === 'parent')*/);
            setAffect([]);
            const data2 = await db.team.toArray();
            setCommerciaux(data2)
            const data3 = await db.agences.toArray();
            setAgence(data3);
        }
        fetchData();
    }, []);
    const refreshClients = async () => {
        const updatedClients = await db.clients.toArray();
        setAllClients(updatedClients);
    };

    const handleDisableClick = async (codeClient, codeAgence) => {
        try {
            await axios.put(url + 'client/affect', {
                clients: [`${codeClient} - ${codeAgence}`],
                codeCommercial: null,
            }, {
                headers: {
                    'Content-type': 'Application/json',
                    'Authorization': 'Bearer ' + userInfo.token
                }
            });

            await db.clients.update({ codeClient, codeAgence }, { commercial: null });

            handleFilter({ searchTerm: currentSearch });
            await refreshClients();

        } catch (error) {
            console.error("Erreur lors de la dissociation :", error);
        }
    };

    

    const handleAssignCommercial = async () => {

        if (!associerDissocier || associerDissocier === 'aucun') {
            alert("Veuillez sélectionner un commercial.");
            return;
        }

        if (selectedClients.length === 0) {
            alert("Aucun client sélectionné.");
            return;
        }

        try {
            const clientsToUpdate = selectedClients.map(key => {
                const [codeClient, codeAgence] = key.split("-");
                return `${codeClient} - ${codeAgence}`;
            });
            
            await axios.put(url + 'client/affect', {
                clients: clientsToUpdate,
                codeCommercial: associerDissocier,
            }, {
                headers: {
                    'Content-type': 'Application/json',
                    'Authorization': 'Bearer ' + userInfo.token
                }
            });

            for (let key of selectedClients) {
                const [codeClient, codeAgence] = key.split('-');
                await db.clients.update({ codeClient, codeAgence }, { commercial: associerDissocier });
            }

            setSelectedClients([]);
            await refreshClients();
            handleFilter();
            alert("Affectation réussie !");
        } catch (error) {
            console.error("Erreur de consolidation :", error);
            alert("Erreur lors de l'affectation.");
        }
    }

    useEffect(() => {
        handleFilter();
        setAllChecked(false);
    }, [selectedAgence, associerDissocier, addComm, submitData]);


    const handleFilter = () => {
        db.clients.toArray().then((data) => {
            let filteredData = [];
            data.filter(d => d.typeClient === 'client-effectif'|| d.typeClient === 'parent')
            
            if (submitData.searchTerm) {
                const [codeClient, , codeAgence] = submitData.searchTerm.split(" / ").map(term => term.trim());
                if (codeClient) {
                    filteredData = data.filter((client) =>
                        client.codeClient === codeClient &&
                        (!codeAgence || client.codeAgence === codeAgence) &&
                        (client.typeClient === 'client-effectif' || client.typeClient === 'parent')
                    );
                }
            } else {
                if (selectedAgence === "aucun") {
                    filteredData = [];
                } else if (selectedAgence) {
                    filteredData = data.filter((client) => client.codeAgence === selectedAgence &&
                    (client.typeClient === 'client-effectif' || client.typeClient === 'parent'));
                } else {
                    filteredData = data;
                }
            }
    
            filteredData = filteredData.sort((a, b) => {
                const nomA = a.nomClient || '';
                const nomB = b.nomClient || '';
                return nomA.localeCompare(nomB, 'fr', { sensitivity: 'base' });
            });
            setAffect(filteredData);
        });
    };

    const handleSelectAll = () => {
        const filteredKeys = affect
            .filter(client => !client.commercial || client.commercial === '')
            .map(client => `${client.codeClient}-${client.codeAgence}`);

        if (allChecked) {
            setSelectedClients(prev => prev.filter(k => !filteredKeys.includes(k)));
        } else {
            setSelectedClients(prev => [...new Set([...prev, ...filteredKeys])]);
        }

        setAllChecked(!allChecked);
    };
    


    
    return (
        <div className='flex flex-row h-full w-full fixed'>
            <Sidebar />
            <div className="relative flex flex-col w-full h-full bg-bleuBlanc">
                <div className="h-[15%] w-full">
                    <Title title="Affectations Clients" btn={false} onSubmitFilter={setSubmitData} />
                </div>
                <div className="p-1 h-[85%] w-full flex flex-row ">
                    <div className='w-full h-full font-bahn flex '>
                        <div className='flex flex-col h-full w-[70%]'>
                            <div className="flex items-center ">
                                <input
                                    type="checkbox"
                                    checked={allChecked}
                                    onChange={handleSelectAll}
                                    className="mr-2"
                                />
                                <label className="text-sm text-marineLogo font-semibold">
                                    {allChecked ? "Tout décocher" : "Tout cocher"}
                                </label>
                            </div>
                            <div className='h-[4%] w-full'>
                                <table className="table-fixed h-[100%] border-collapse items-center bg-transparent w-full ">
                                    <thead className='h-full max-h-1.5'>
                                        <tr className='bg-marineLogo text-blanc'>
                                            <th className="sticky align-middle border border-solid border-marineLogo text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">Client</th>
                                            <th className="sticky align-middle border border-solid border-marineLogo text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
                                                Agence :
                                                <select
                                                    value={selectedAgence}
                                                    onChange={(e) => setSelectedAgence(e.target.value)}
                                                    className="ml-2 text-xs bg-marineLogo text-blanc border-none"
                                                >
                                                    <option value="aucun">Aucune</option>
                                                    <option value="">Toutes</option>
                                                    {agence.map((agenceItem) => (
                                                        <option key={agenceItem.code} value={agenceItem.code}>
                                                            {agenceItem.nom}
                                                        </option>
                                                    ))}
                                                </select>
                                                
                                            </th>
                                            <th className="sticky align-middle border border-solid border-marineLogo text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
                                            Commercial :
                                            </th>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                            <div className='w-full overflow-y-auto scrollbar scrollbar-thin scrollbar-thumb-roseLogo scrollbar-track-grey100'>                
                                <table className="table-fixed border-collapse items-center bg-transparent w-full">
                                    <tbody className='h-auto overflow-y-auto scrollbar scrollbar-thin scrollbar-thumb-roseLogo scrollbar-track-grey100'>
                                        {affect.map((client, index) => (
                                            <tr key={index} className='max-h-[10%] min-h-[5%] border border-b-1 border-l-0 border-r-0 border-marineLogo'>
                                                <td className=" border-t-0 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap text-left text-marineLogo">{client.nomClient}<br />  <span className='text-noir'>({client.codeClient})</span></td>
                                                <td className="border-t-0 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap ">{client.codeAgence}</td>
                                                <td>
                                                {client.commercial && client.commercial !== '' ? (
                                                    <div className='flex'>
                                                    
                                                        {commerciaux.filter((commercial) => commercial.idUser == client.commercial)
                                                        .map((commercial) => (
                                                            <span key={commercial.id}>
                                                            {commercial.firstName} {commercial.name}
                                                            </span>
                                                        ))}
                                                        <svg
                                                            onClick={() => {
                                                                handleDisableClick(client.codeClient, client.codeAgence);
                                                                setShowSelect((prev) => ({
                                                                    ...prev,
                                                                    [`${client.codeClient}-${client.codeAgence}`]: true,
                                                                }));
                                                            }}
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            fill="none"
                                                            viewBox="0 0 24 24"
                                                            strokeWidth="1.5"
                                                            stroke="#952A5A"
                                                            className="w-6 h-6"
                                                        >
                                                            <path
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            d="M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
                                                            />
                                                        </svg>
                                                    
                                                    </div>
                                                ) : (
                                                    <div className='flex'>
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedClients.includes(`${client.codeClient}-${client.codeAgence}`)}
                                                            onChange={(e) => {
                                                                const key = `${client.codeClient}-${client.codeAgence}`;
                                                                setSelectedClients((prev) =>
                                                                e.target.checked ? [...prev, key] : prev.filter(k => k !== key)
                                                                );
                                                            }}
                                                            className="mr-2"
                                                        />

                                                        
                                                    </div>
                                                )}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            <div className="mt-2 p-1 bg-gray-100 rounded-md h-[32%]">
                                
                            <div className='flex'>
                                <div className="flex-1">
                                    <label className="block text-sm font-semibold text-marineLogo">Commercial :</label>
                                    <select
                                        value={associerDissocier}
                                        onChange={(e) => setAssocierDissocier(e.target.value)}
                                        className="mt-1 ml-2 p-2 bg-blanc w-full  text-marineLogo border border-marineLogo rounded-md"
                                    >
                                        <option value="aucun">Aucun</option>
                                        <option value="">Tous</option> 
                                        {commerciaux.map((commercial) => ( 
                                            <option key={commercial.idUser} value={commercial.idUser}>
                                                {commercial.name} {commercial.firstName}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                
                                
                            </div>
                            <label className="block text-sm font-semibold text-marineLogo mt-2">Liste des clients :</label>
                            <div className="overflow-y-auto max-h-32 scrollbar scrollbar-thin scrollbar-thumb-roseLogo scrollbar-track-grey100">
                                <ul className="pl-5 list-disc text-marineLogo">
                                    {selectedClients.map((key, index) => (
                                        <li key={index}>{key}</li>
                                    ))}
                                </ul>
                            </div>
                            <button 
                                onClick={handleAssignCommercial} 
                                className="mt-2 w-full bg-vertLogo text-blanc py-2 rounded-md font-semibold hover:bg-blanc hover:border hover:border-vertLogo hover:text-vertLogo"
                            >
                                Valider la Consolidation
                            </button>
                        </div>
                            
                        </div>
                        <div className='pt-4 flex flex-col w-[18%]'>
                            <div className='h-[4%] w-full ml-2'>
                                <table className="h-full border-collapse items-center bg-transparent w-full "> 
                                    <thead className='h-full max-h-1.5'>
                                        <tr className='bg-marineLogo text-blanc'>
                                            <th className="sticky align-middle border border-solid border-marineLogo text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
                                                Commercial :
                                                <select
                                                    value={associerDissocier}
                                                    onChange={(e) => setAssocierDissocier(e.target.value)}
                                                    className="ml-2 text-xs bg-marineLogo text-blanc border-none"
                                                >
                                                    <option value="aucun">Aucun</option>
                                                    <option value="">Tous</option> 
                                                    {commerciaux.map((commercial) => ( 
                                                            <option key={commercial.idUser} value={commercial.idUser}>
                                                                {commercial.name} {commercial.firstName}
                                                            </option>
                                                        ))}
                                                </select>
                                            </th>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                            <div className='w-full overflow-y-auto scrollbar scrollbar-thin scrollbar-thumb-roseLogo scrollbar-track-grey100'>
                                <table className=" h-full border-collapse items-center bg-transparent w-full ">
                                    <tbody className='h-auto overflow-y-auto scrollbar scrollbar-thin scrollbar-thumb-roseLogo scrollbar-track-grey100'>
                                    {allClients
                                        .filter(client => associerDissocier && client.commercial === associerDissocier)
                                        .sort((a, b) => {
                                            const nomA = a.nomClient || '';
                                            const nomB = b.nomClient || '';
                                            return nomA.localeCompare(nomB, 'fr', { sensitivity: 'base' });
                                        })
                                        .map((client, index) => (
                                            <tr key={`commercial-client-${index}`} className='border-b border-marineLogo'>
                                                <td className="text-xs text-marineLogo whitespace-nowrap p-2">
                                                    {client.nomClient} <br />
                                                    <span className='text-noir'>({client.codeClient} / {client.codeAgence})</span>
                                                </td>
                                            </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Affect;